import React from "react"
import {Button, ButtonProps, Text} from "../../vanilla"
import {Nullable} from "../../types/utils"
import {Hit} from "../../store/ProductStore"
import {getDisabledButtonText} from "../../utils/utils"

interface AddToBasketButtonProps extends ButtonProps {
    hit: Hit,
    displayPrice: Nullable<number>
    isPLPTile?: boolean
    isPDPPage?: boolean
}

export const ATBButton = React.forwardRef((props: AddToBasketButtonProps, ref: React.Ref<HTMLButtonElement>) => {
    const { 
        hit,
        displayPrice,
        isPLPTile,
        isPDPPage,
        ...rest 
    } = props

    // Possible reasons ATB button would be disabled:
    // 1. global inStock flag is set to false (Handled in transformHits and part of availableforDayAtStore check)
    // 2. Product has no display price
    // 3. Product is not available for sale on the current slot/store combination
    // 4. Product is badged with the isAddToCartDisabled flag
    const isButtonDisabled = !displayPrice 
                            || !hit.availableForDayAtStore 
                            || hit.isAddToCartDisabled === true 


    return (
        <Button 
        variant={!isButtonDisabled ? "primary" : "secondary"} 
        disabled={isButtonDisabled}
        size={(isPDPPage || isPLPTile) ? "smWide" : "sm"}
        paddingY={(isPDPPage || isPLPTile) ? "8px" : "0px"}
        data-test-selector="add-to-basket-button"
        {...rest}
        ref={ref}>
            <Text variant="unstyled" fontSize={isPDPPage ? "sm" : "inherit"} display={isPLPTile ? ['none', 'block'] : 'block'}>{!isButtonDisabled ? 'Add to Basket' : getDisabledButtonText(hit.disabledStatus)}</Text>
            <Text variant="unstyled" fontSize={isPLPTile ? "sm" : "inherit"} display={isPLPTile ? ['block', 'none'] : 'none'}>
                {!isButtonDisabled ? 'Add' : getDisabledButtonText(hit.disabledStatus)}
            </Text>
        </Button>
    )
})
